import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Suivi live d'une génération de quiz par IA (QZ-1204). La carte de progression
// est remplacée en direct par un broadcast Turbo à chaque étape. Quand l'état
// devient terminal (succeeded/failed), on recharge la page pour afficher la
// carte finale rendue CÔTÉ SERVEUR (liens propres à chaque espace).
export default class extends Controller {
  static targets = ["signal"];
  static values = { fallbackMs: { type: Number, default: 90000 } };

  connect() {
    // Filet de sécurité si un broadcast est manqué (cable tombé, course au
    // premier rendu) : un seul rechargement différé tant que non terminal.
    this.fallback = setTimeout(() => this.refreshOnce(), this.fallbackMsValue);
  }

  disconnect() {
    if (this.fallback) clearTimeout(this.fallback);
  }

  // Rappelé à chaque (re)connexion de la carte de progression — donc à chaque
  // broadcast. Le premier appel note l'état initial (déjà rendu par le serveur).
  signalTargetConnected(el) {
    const status = el.dataset.status;
    if (this.seen === undefined) {
      this.seen = status;
      return;
    }
    if (status === "succeeded" || status === "failed") this.refreshOnce();
  }

  refreshOnce() {
    if (this.reloaded) return;
    this.reloaded = true;
    if (this.fallback) clearTimeout(this.fallback);
    Turbo.visit(window.location.href, { action: "replace" });
  }
}
